import { useEffect, useRef, useState } from 'react';
import { stableStringify } from './editDiff';

/**
 * Erkennt Eingaben in einem Dialog, dessen Felder als einzelne Zustände vorliegen: merkt
 * sich den Stand kurz nach dem Öffnen und meldet, sobald die Werte davon abweichen. Für
 * den Dialog-Schutz (useGuardedClose) bestehender Dialoge, ohne sie auf eine Arbeitskopie
 * umzubauen.
 *
 * Der Stand wird nach einem Moment gemerkt, nicht sofort: Viele Dialoge belegen ihre Felder
 * erst in einem Effekt nach dem Öffnen vor — das ist keine Eingabe des Anwenders.
 *
 * `resetKey` wechselt, wenn derselbe Dialog einen anderen Datensatz zeigt.
 */
export function useDirtySnapshot(open: boolean, value: unknown, resetKey?: string | number | null): boolean {
  const current = stableStringify(value);
  const live = useRef(current);
  live.current = current;
  const [base, setBase] = useState<string | null>(null);

  useEffect(() => {
    setBase(null);
    if (!open) return;
    const t = window.setTimeout(() => setBase(live.current), 80);
    return () => window.clearTimeout(t);
  }, [open, resetKey]);

  return open && base != null && base !== current;
}
